export const FETCH_USER = 'fetch_user';